<template>
  <img
    :key="imageKey"
    class="course-image"
    :class="{ 'course-image--list': list }"
    :src="imageSrc"
    :alt="course.title"
    :title="course.title" />
</template>

<script lang="ts" setup>
import type { CourseBase } from "@/models/course";
import useCompanyCoursesService from "@/services/useCompanyCoursesService";
import { imageDefaultForCourses } from "@/constants/urls";
import { computed, onMounted, ref } from "vue";

const { getLearningImageCover } = useCompanyCoursesService();

interface Props {
  course: CourseBase;
  list?: boolean;
}

const props = withDefaults(defineProps<Props>(), { list: false });

const imageSrc = ref<string>(imageDefaultForCourses);

const imageKey = computed<string>(
  () => `${props.course.id}-${props.course.companyCourseInformation?.imageCoverName ?? props.course.imageUrl ?? imageDefaultForCourses}`
);

onMounted(async () => {
  if (props.course.companyCourseInformation?.imageCoverName) {
    try {
      const blob = await getLearningImageCover(props.course.id, props.course.companyCourseInformation.imageCoverName);
      imageSrc.value = URL.createObjectURL(blob);
    } catch {
      imageSrc.value = imageDefaultForCourses;
    }
  }
});
</script>

<style lang="scss" scoped>
.course-image {
  object-fit: cover;
  height: 25rem;
  width: 100%;

  &--list {
    height: 100%;
    width: unset;
    max-width: 28rem;
    border-radius: 6px 0 0 6px;
  }
}
</style>
